import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { CapabilityService } from '@libs/shared/services';

export const DocumentsGuard: CanActivateFn = (): boolean => {
  return inject(CapabilityService).isAvailable('services.documents')();
};
